import { ReloadOutlined } from '@ant-design/icons';
import { Button, Segmented, Select } from 'antd';
import type { AccessResponse, CreatorKind } from '../contract';
import { KIND_OPTIONS, fmtMonth } from '../format';
import styles from '../style.module.scss';

interface Props {
  access: AccessResponse;
  month: string;
  groupId: number | null;
  kind: CreatorKind | null;
  recomputing: boolean;
  onMonth: (month: string) => void;
  onGroup: (groupId: number | null) => void;
  onKind: (kind: CreatorKind | null) => void;
  onRecompute: () => void;
}

const ALL_GROUPS = 0;

/** Ô Nhóm ẩn khi phạm vi chỉ có ≤ 1 nhóm và không phải ALL (đặc tả §8.1). */
export const showGroupFilter = (access: AccessResponse) =>
  !(access.groups.length <= 1 && access.scope !== 'ALL');

/** Thanh lọc: Tháng · Nhóm · Loại · nút "Tính lại" (chỉ Admin). */
const FilterBar = ({
  access,
  month,
  groupId,
  kind,
  recomputing,
  onMonth,
  onGroup,
  onKind,
  onRecompute,
}: Props) => {
  const groupOptions = [
    {
      value: ALL_GROUPS,
      label: access.scope === 'ALL' ? 'Tất cả nhóm' : 'Tất cả nhóm của tôi',
    },
    ...access.groups.map((g) => ({
      value: g.id,
      label: `${g.name}${g.kind === 'STUDIO' ? ' (Studio)' : ''}`,
    })),
  ];

  return (
    <div className={styles.toolbar} role="search" aria-label="Bộ lọc phân tích">
      <label className={styles.field}>
        <span className={styles.fieldLabel}>Tháng</span>
        <Select<string>
          className={styles.monthSelect}
          value={month}
          onChange={onMonth}
          options={access.months.map((m) => ({ value: m, label: fmtMonth(m) }))}
        />
      </label>

      {showGroupFilter(access) && (
        <label className={styles.field}>
          <span className={styles.fieldLabel}>Nhóm</span>
          <Select<number>
            className={styles.groupSelect}
            showSearch
            optionFilterProp="label"
            value={groupId ?? ALL_GROUPS}
            onChange={(v) => onGroup(v ? v : null)}
            options={groupOptions}
          />
        </label>
      )}

      <div className={styles.field}>
        <span className={styles.fieldLabel}>Loại Creator</span>
        <div className={styles.kindScroll}>
          <Segmented<string>
            value={kind ?? 'ALL'}
            onChange={(v) => onKind(v === 'ALL' ? null : (v as CreatorKind))}
            options={KIND_OPTIONS.map((o) => ({ label: o.label, value: o.value }))}
          />
        </div>
      </div>

      {access.isAdmin && (
        <Button
          className={styles.recompute}
          icon={<ReloadOutlined />}
          loading={recomputing}
          onClick={onRecompute}
        >
          Tính lại
        </Button>
      )}
    </div>
  );
};

export default FilterBar;
